<template>
    <li
        role="menuitem"
        :class="[ activeLink ? 'selected' : '' ]"
        @keydown.tab="emitFocus"
    >
        <router-link
            v-slot="{ href, isExactActive }"
            :to="to"
            class="routerlink"
            custom
        >
            <a
                :href="href"
                :class="[ 'navigation-font',
                          displaySmallOrExtraSmall ? 'burger' : '' ]"
                :aria-current="isExactActive ? 'page' : null"
                @click.self.prevent="navigateOrClose($event, to, isExactActive)"
                @keydown.space.prevent="navigateOrClose($event, to, isExactActive)"
                @keydown.esc="hideLinks()"
            >
                {{ $t(textTerm) }}
            </a>
        </router-link>
    </li>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"
    import router from "@/router/router"

    @Component
    export default class CustomRouterLink extends Vue {
        @Prop({ type: String, default: "" }) to!: string
        @Prop({ type: String }) textTerm: string | undefined
        @Prop({ type: Number }) index: number | undefined

        get activeLink(): boolean {
            return this.$route.fullPath.includes(this.to)
        }

        // ruutukoko
        get displayType(): string {
            return this.$store.getters.displayType
        }

        get displaySmall(): string {
            return this.$store.state.displaySmall
        }

        get displayExtraSmall(): string {
            return this.$store.state.displayExtraSmall
        }

        get displaySmallOrExtraSmall(): boolean {
            return this.displayType === this.displaySmall || this.displayType === this.displayExtraSmall
        }

        // Navigoi uudelle sivulle tai sulje mobiilimenu, jos kyseessä sama sivu
        navigateOrClose(e, route, isExactActive: boolean) {
            if (!isExactActive) {
                this.$emit("hideLinks")
                // this.$router.push(route)
                router.push(route)
            }
            else {
                this.$emit("closeHamburgerMenu")
            }
        }

        hideLinks() {
            this.$emit("hideLinks")
        }

        emitFocus(event: KeyboardEvent) {
            // Emitoidaan focuksen siirto vain, jos shiftiä ei paineta tabin lisäksi
            // eli vain jos valikon itemeissä liikutaan eteenpäin
            if (!event.shiftKey) /* jos pelkkä tab */ {
                this.$emit('focus', this.index)
            }
        }
    }
</script>

<style scoped>
    li {
        text-align: left;
        border-left: 5px solid transparent;
    }

        li:hover {
            background-color: #F2F4F8;
            border-left: 5px solid var(--Traficom-main-color);
            cursor: pointer;
        }

        li.selected {
            border-left: 5px solid var(--Traficom-main-color);
        }

        li a {
            padding: 15px 20px;
            background: none;
            display: block;
        }

            li a.burger {
                padding: 15px 20px 15px 15px;
            }

                li a.burger:focus {
                    outline: 3px solid var(--Traficom-main-color);
                    outline-offset: -4px;
                }
    .link-list li a:focus {
        outline: 3px solid var(--Traficom-main-color);
        outline-offset: -6px;
    }
</style>
